<template>
  <div v-if="isLinkInvalid" class="space-y-2 text-center">
    <h1 class="font-medium">{{ t('linkInvalidTitle') }}</h1>
    <p>{{ t('linkInvalidText') }}</p>
  </div>
  <div v-else class="space-y-4 text-center">
    <Spinner class="mx-auto" />
    <p class="text-gray-500">{{ t('signingIn') }}</p>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Spinner from '@/components/icons/Spinner.vue';
import { useExternalHandoverLogin } from '@/queries/use-external-handover';

/** Opening the External handover link signs the driver in, or shows why not (ADR 0021). */
const props = defineProps<{
  token?: string;
}>();

const { t } = useI18n();
const router = useRouter();
const { mutateAsync: login } = useExternalHandoverLogin();
const isLinkInvalid = ref(false);

onMounted(async () => {
  if (!props.token) return;
  try {
    const { bookingId } = await login(props.token);
    await router.replace({ name: 'handoverDetail', params: { id: bookingId } });
  } catch {
    isLinkInvalid.value = true;
  }
});
</script>

<i18n lang="json">
{
  "en": {
    "linkInvalidTitle": "Link no longer valid",
    "linkInvalidText": "This handover link has been replaced or the handover is already done. Please contact the station.",
    "signingIn": "Signing you in …"
  },
  "de": {
    "linkInvalidTitle": "Link nicht mehr gültig",
    "linkInvalidText": "Dieser Übergabelink wurde ersetzt oder die Übergabe ist bereits erledigt. Bitte wende dich an die Station.",
    "signingIn": "Du wirst angemeldet …"
  },
  "es": {
    "linkInvalidTitle": "El enlace ya no es válido",
    "linkInvalidText": "Este enlace de entrega se ha sustituido o la entrega ya está hecha. Ponte en contacto con la estación.",
    "signingIn": "Iniciando sesión …"
  }
}
</i18n>
